import { LOCALES } from "../locales";

export default {
  [LOCALES.RUSSIAN]: {
    // ==================== BUTTONS ====================
    "button.login": "Войти",
    "button.submit": "Отправить",
    "button.cancel": "Назад",
    "button.delete": "Удалить",
    "button.edit": "Изменить",
    "button.print": "Печать",
    "button.sell": "Продать",
    "button.clear": "Очистить",
    "button.add_payment": "Добавить оплату",
    "button.save": "Сохранить",
    "button.generate_contract": "Генерация договора",
    "button.contract": "Договор",
    "button.sign": "Подписать",
    "button.manager_signed": "Подписано менеджером",
    "button.verify_user": "Подтвердить пользователя",
    "button.send_sms": "Отправить SMS",
    "button.download": "Скачать",

    // ==================== FORM LABELS ====================
    "form.label.username": "Пользователь:",
    "form.label.password": "Пароль:",
    "form.label.customer_name": "ФИО клиента",
    "form.label.customer_phone": "Номер клиента",
    "form.label.customer_phone2": "Дополнительный телефон",
    "form.label.email": "Email",
    "form.label.sale_status": "Статус продажи",
    "form.label.price_per_sqm": "Изменение цены за 1 м² ($)",
    "form.label.initial_payment": "Первоначальный взнос (%)",
    "form.label.payment_duration": "Срок оплаты (мес)",
    "form.label.installment": "Рассрочка",
    "form.label.booked": "Бронь",
    "form.label.additional_info": "Дополнительная информация",
    "form.label.signatory": "Подписант",
    "form.error.signatory_required": "Выберите подписанта",
    "form.label.payment_amount": "Сумма оплаты:",
    "form.label.payment_type": "Тип оплаты",
    "form.label.address": "Адрес",
    "form.label.passport_given_place": "Место выдачи паспорта",
    "form.label.passport_given_date": "Дата выдачи паспорта",
    "form.label.series": "Серия паспорта",
    "form.label.pnfl": "ПИНФЛ",
    "form.label.birth_date": "Дата рождения",
    "form.label.booking_payment": "Оплата за бронь",
    "form.label.payment_method": "Способ оплаты",
    "form.label.upload_file": "Загрузить файл",
    "form.label.file_comment": "Комментарий к файлу",
    "form.label.attached_file": "Прикреплённый файл",
    "form.label.repair": "Ремонт",
    "form.label.repair_with": "С ремонтом",
    "form.label.repair_without": "Без ремонта",

    // ==================== FORM VALIDATION ====================
    "form.error.username_required": "Введите имя пользователя!",
    "form.error.password_required": "Введите пароль!",
    "form.error.customer_name_required": "Введите имя клиента!",
    "form.error.customer_phone_required": "Введите номер клиента",
    "form.error.customer_phone2_required": "Введите дополнительный номер телефона",
    "form.error.email_required": "Введите email",
    "form.error.email_invalid": "Неверный формат email",
    "form.error.phone_incomplete": "Пожалуйста, введите полный номер!",
    "form.error.price_required": "Введите цену за площадь!",
    "form.error.initial_payment_required": "Введите первоначальный взнос!",
    "form.error.duration_required": "Введите срок оплаты!",
    "form.error.amount_required": "Введите сумму оплаты!",
    "form.error.address_required": "Введите адрес!",
    "form.error.passport_given_place_required": "Введите место выдачи паспорта!",
    "form.error.passport_given_date_required": "Введите дату выдачи паспорта!",
    "form.error.series_required": "Введите серию паспорта!",
    "form.error.pnfl_required": "Введите ПИНФЛ!",
    "form.error.birth_date_required": "Введите дату рождения!",
    "form.error.birth_date_min_age": "Клиент должен быть старше 18 лет!",
    "form.error.phone_length": "Номер телефона слишком короткий!",
    "form.error.password_min": "Пароль должен содержать минимум 8 символов!",
    "form.error.full_name_required": "Введите полное имя!",
    "form.error.role_required": "Выберите роль!",
    "form.error.phone_required": "Введите номер телефона!",
    "form.error.name_required": "Введите название!",
"form.label.initial_payment_discount":"Процент скидки",
    "form.error.initial_payment_discount_required":"Введите процент скидки",
    "form.error.booking_payment_required": "Введите сумму оплаты за бронь!",
    "form.error.type_required": "Выберите статус продажи!",
    "form.label.day_of_payment": "День оплаты",
    "form.error.day_of_payment_required": "Введите день оплаты!",
    "form.label.client_type": "Тип клиента",
    "form.label.individual": "Физическое лицо",
    "form.label.legal": "Юридическое лицо",
    "form.label.manual": "Вручную",
    "form.label.via_myid": "Через MYID",
    "form.label.director": "Директор",
    "form.label.bank": "Банк",
    "form.label.bank_account": "Расчётный счёт",
    "form.label.mfo_code": "Код МФО",
    "form.label.oked_code": "Код ОКЭД",
    "form.label.inn": "ИНН",
    "form.error.director_required": "Введите имя директора!",
    "form.error.bank_required": "Введите название банка!",
    "form.error.bank_account_required": "Введите расчётный счёт!",
    "form.error.mfo_code_required": "Введите код МФО!",
    "form.error.oked_code_required": "Введите код ОКЭД!",
    "form.error.inn_required": "Введите ИНН!",
    // ==================== STATUS VALUES ====================
    "status.sold": "Продано",
    "status.booked": "Забронировано",
    "status.not_paid": "Не полностью оплачено",
    "status.empty": "Свободно",
    "status.not_for_sale": "Не продаётся",
    "status.active": "Активный",
    "status.blocked": "Заблокирован",
    "status.reserved_paid": "Оплаченная бронь",

    // ==================== TABLE COLUMNS ====================
    "table.column.no": "№",
    "table.column.username": "Имя пользователя",
    "table.column.role": "Роль",
    "table.column.phone": "Телефон",
    "table.column.status": "Статус",
    "table.column.action_type": "Тип действия",
    "table.column.target": "Цель",
    "table.column.timestamp": "Время выполнения",
    "table.column.actions": "Действия",
    "table.column.amount": "Сумма",
    "table.column.payment_time": "Время оплаты",
    "table.column.delete": "Удалить",
    "table.column.total_area": "Общая площадь",
    "table.column.total_paymentm2": "Общая стоимость площади",
    "table.column.total_paymentRepair": "Общая стоимость ремонта",

    "table.column.total_payment": "Общая оплата",
    "table.column.total_payment_discount": "Цена со скидкой",
    "table.column.initial_payment": "Первоначальный взнос",
    "table.column.monthly_payment": "Ежемесячный платёж",

    // ==================== APARTMENT INFO ====================
    "apartment.info": "Информация о квартире",
    "apartment.size": "Площадь:",
    "apartment.rooms": "Количество комнат:",
    "apartment.floor": "Этаж:",
    "apartment.status": "Статус недвижимости:",
    "apartment.price": "Цена:",
    "apartment.lodjiya": "Лоджия:",
    "apartment.block": "Блок:",
    "apartment.building": "Здание",
    "apartment.area": "Площадь:",
    "apartment.apartment_number": "№ Недвижимости:",
    "navbar.current_dollar_rate": "Текущий курс доллара:",
    "apartment.pcs":"",

    // ==================== PARKING INFO ====================

    "menu.apartments": "Квартиры",
    "menu.office": "Коммерческая недвижимость",
    "menu.parking": "Машино-место",
    "menu.storage_room": "Кладовая",

    // ==================== STORAGE ROOM INFO ====================
    "storage_room.number": "Номер кладовки:",

    // ==================== SALE INFO ====================
    "sale.info": "Информация о сделке",
    "sale.customer_name": "ФИО клиента:",
    "sale.customer_phone": "Номер клиента:",
    "sale.sold_price_sqm": "Цена продажи (м²):",
      "sale.user":"Менеджер:",
    "sale.initial_payment": "Первоначальный взнос:",
    "sale.monthly_payment": "Ежемесячный платёж ({months}мес):",
    "sale.additional_info": "Дополнительная информация:",
    "sale.delete_order": "Удалить заказ",
    "sale.reserved.day":"Дата бронирования (день)",
    // ==================== PAYMENT INFO ====================
    "payment.info":"Информация об оплате",
    "payment.add":"Добавить оплату",
    "payment.cash": "Оплата 100%",
    "payment.card": "Карта",
    "payment.delete_confirm": "Вы действительно хотите удалить оплату?",
    "payment.delete_warning": "После удаления оплаты её нельзя будет восстановить!",
    "payment.delete_success": "Оплата удалена",
    "payment.delete_error": "Не удалось удалить оплату",
    "payment.upload_check": "Загрузить чек",
    "payment.installment": "Рассрочка",
    "payment.booking": "Бронирование",
    "payment.click": "Click",
    "payment.payme": "Payme",
    "payment.check": "Чек",
    "payment.amount_placeholder": "Сумма (UZS):",

    // ==================== ORDER INFO ====================
    "order.delete_confirm": "Вы действительно хотите удалить заказ?",
    "order.delete_warning": "После удаления заказа его нельзя будет восстановить, и все платежи также будут удалены!",
    "order.delete_success": "Заказ удалён",
    "order.delete_error": "Не удалось удалить заказ",

    // ==================== FILTERS ====================
    "filter.title": "Фильтры",
    "filter.floors": "Этажи:",
    "filter.buildings": "Здания:",
    "filter.all_buildings": "Все здания",
    "filter.building": "Здание",
    "filter.area": "Площадь квартиры:",
    "filter.room_count": "Типы квартир:",
    "filter.sale_room_count": "Типы проданных квартир:",
    "filter.clear": "Очистить",
    "filter.floor_suffix": "этаж",
    "filter.room_suffix": "комн.",
    "filter.sale_room_suffix": "Проданная комната",
    "filter.sync":"Синхронизация",
    "filter.exclude_smoke":"Квартиры с эркерами.",
    "filter.status": "Статус:",
    "filter.all_status": "Все статусы",
    "filter.all": "Все",
    "filter.show_favorites": "Только избранные",

    // ==================== MENU/SIDEBAR ====================
    "menu.erp": "ERP",
    "menu.admin": "Админ",
    "menu.chess": "Шахматка",
    "menu.catalogs": "Каталоги",
    "menu.blocks": "Блоки",
    "menu.floors": "Этажи",
    "menu.schema": "Схема",
    "menu.users": "Пользователи",
    "menu.log": "Действия",

    // ==================== USER MENU ====================
    "user.profile": "Мой профиль",
    "user.logout": "Выход",

    // ==================== MESSAGES ====================
    "message.success.updated": "Успешно изменено",
    "message.success.created": "Успешно создано",
    "message.success.deleted": "Успешно удалено!",
    "message.error.occurred": "Произошла ошибка",
    "message.error.delete": "Ошибка при удалении!",
    "message.loading": "Загрузка...",
    "message.confirm.delete": "Вы действительно хотите удалить?",

    // ==================== CRM ====================
    "crm.all": "Все",
    "crm.new": "Новые",
    "crm.in_progress": "В процессе",
    "crm.completed": "Завершённые",
    "crm.canceled": "Отменённые",
    "crm.archived": "Архивированные",
    "crm.deleted": "Удалённые",
    "crm.spam": "Спам",
    "crm.trash": "Корзина",
    "crm.leads": "лидов:",

    // ==================== PRINT ====================
    "print.title": "Данные для печати",
    "print.document_title": "КВАРТИРА С ПЛОЩАДЬЮ",
    "print.address": "Адрес:",
    "print.sales_address": "Адрес отдела продаж:",
    "print.sales_phone": "Номер отдела продаж:",
    "print.remaining_amount": "Остаток:",
    "print.price_per_sqm": "Цена за 1м²:",

    // ==================== MISC ====================
    "misc.remember_me": "Запомнить меня",
    "misc.search": "Поиск",
    "misc.month": "мес",
    "misc.currency": "UZS",
    "misc.sqm": "м²",
    "misc.percent": "%",
    "misc.room": "Комната",
    "misc.blocks": "Блоки",

    // ==================== ROLES ====================
    "role.seller": "Менеджер",
    "role.admin": "Админ",
      "role.finance": "Финансы",

    "role.superadmin": "Суперадмин",
    "role.director": "Директор",

    // ==================== PAGES ====================
    "page.users": "Страница пользователей",
    "page.actions": "Страница действий",
    "page.catalogs": "Каталоги",

    // ==================== LANGUAGE ====================
    "language.uzbek": "O'zbek",
    "language.russian": "Русский",

    // ==================== COMMON (legacy support) ====================
    "common.page.user": "Страница пользователей",
    "common.page.action": "Страница действий",
    "common.username": "Имя пользователя",
    "common.status": "Статус",
    "common.full_name": "Полное имя",
    "common.name": "Название",
    "common.role": "Роль",
    "common.phone": "Телефон",
    "common.search": "Поиск",
    "common.password": "Пароль",
    "common.delete": "Удалить",
    "common.yes": "Да",
    "common.no": "Нет",
    "common.foods": "Еда",
    "common.services": "Услуги",
    "common.start_time": "Время начала",
    "common.end_time": "Время окончания",
    "common.customer_name": "Имя клиента",
    "common.total_people": "Количество людей",
    "common.currency": "Валюта",
    "common.description": "Подробная информация",
    "common.customer_phone": "Номер клиента",
    "common.total_budget": "Общая стоимость",
    "common.individual_package": "Цена на человека",
    "common.sidebar.chess": "Шахматка",
    "common.sidebar.dashboard": "Дашбоард",
    "common.sidebar.catalogs": "Каталоги",
    "common.sidebar.blocks": "Блоки",
    "common.sidebar.floors": "Этажи",
    "common.sidebar.schema": "Схема",
    "common.sidebar.users": "Пользователи",
    "common.sidebar.log": "Действия",
    "common.sidebar.dollar_rate": "Курс доллара",
    "common.sidebar.orders": "Заказы",
    "common.sidebar.delete_orders": "Удалённые заказы",
    "order.deleted.page.title": "Удалённые заказы",
    "order.type.sold": "Продано",
    "order.type.not_full_paid": "Рассрочка",
    "order.type.reserved_paid": "Платная бронь",
    "order.type.mortgage": "Ипотека",
    "order.type.reserved": "Бронь",
    "order.page.title": "Заказы",
    "order.field.id": "ID",
    "order.field.client": "Клиент",
    "order.field.phone": "Телефон",
    "order.field.object": "Объект",
    "order.field.contractNumber": "Номер договора",
    "order.field.signature": "Подпись",
    "order.field.price": "Цена",
    "order.field.priceCurrency": "Валюта",
    "order.field.price_m2": "Цена за 1 м²",
    "order.field.discount": "Скидка",
    "order.field.type": "Тип",
    "order.field.paymentDurationPerMonth": "Срок оплаты (мес.)",
    "order.field.downPaymentPercent": "Первоначальный взнос (%)",
    "order.field.downPaymentSum": "Сумма первоначального взноса",
    "order.field.description": "Описание",
    "order.field.bank": "Банк",
    "order.field.file": "Файл",
    "order.field.fileComment": "Комментарий к файлу",
    "order.field.user": "Менеджер",
    "order.field.apartment": "Квартира",
    "order.field.parking": "Паркинг",
    "order.field.storage": "Кладовка",
    "order.field.contractType": "Тип договора",
    "order.field.contractType.online": "Онлайн",
    "order.field.contractType.offline": "Офлайн",
    "order.field.contract": "Договор",
    "order.field.createdAt": "Дата создания",
    "order.field.updatedAt": "Дата обновления",
    "order.object.apartment": "Квартира",
    "order.object.parking": "Паркинг",
    "order.object.storage": "Кладовка",
    "order.signature.signed": "Подписан",
    "order.signature.unsigned": "Не подписан",
    "order.empty": "-",

    // ==================== INPUT ERRORS (legacy support) ====================
    "input.error.phone-length": "Номер телефона слишком короткий!",
    "input.error.password<8": "Пароль должен содержать минимум 8 символов!",
    "input.required.password": "Введите пароль!",
    "input.required.full_name": "Введите полное имя!",
    "input.required.role": "Выберите роль!",
    "input.required.phone": "Введите номер телефона!",
    "input.required.name": "Введите название!",
    "input.required.foods": "Выберите еду!",
    "input.required.start_time": "Введите время начала!",
    "input.required.end_time": "Введите время окончания!",
    "input.required.customer_name": "Введите имя клиента!",
    "input.required.total_people": "Введите количество людей!",
    "input.required.username": "Введите имя пользователя!",

    // ==================== NOTIFICATIONS (legacy support) ====================
    "notification.success.delete": "Успешно удалено!",
    "notification.error.delete": "Ошибка при удалении!",
    "confirm.delete": "Вы действительно хотите удалить?",

    "chess.big": "Большая шахматка",
    "chess.small": "Маленькая шахматка",
    "floor.high":"Верхний этаж",
    "floor.basement":"Подвал",

    // ==================== DOLLAR RATE ====================
    "dollar_rate.rate": "Курс",
    "dollar_rate.add": "Добавить курс",
    "dollar_rate.edit": "Редактировать курс",
    "dollar_rate.rate_placeholder": "Введите курс",
    "form.error.rate_required": "Введите курс!",
    "button.add": "Добавить",

    // ==================== DASHBOARD ====================
    "dashboard.title": "Дашбоард",
    "dashboard.price.type":"сум",
    "dashboard.total_area": "Общая площадь",
    "dashboard.total_amount": "Общая сумма",
    "dashboard.sold_area": "Проданная площадь",
    "dashboard.unsold_area": "Непроданная площадь",
    "dashboard.sold_average": "Средняя цена проданных домов",
    "dashboard.unsold_average": "Средняя цена непроданных домов",
    "dashboard.by_area": "По площади (м²)",
    "dashboard.by_amount": "По сумме (сум)",
    "dashboard.room_statistics": "Статистика комнат",
    "dashboard.room_statistics_title": "Статистика по комнатам",
    "dashboard.sold": "Продано",
    "dashboard.unsold": "Не продано",
    "dashboard.sold_m2": "Продано (м²)",
    "dashboard.unsold_m2": "Не продано (м²)",
    "dashboard.sold_sum": "Продано (сум)",
    "dashboard.unsold_sum": "Не продано (сум)",
    "dashboard.room_suffix": "комн.",

    // parking

    "parking.number":"Номер места жительства",
    "parking.info":"Информация о размещении",

  //   storage rooms
    "storage.number":"Номер склада",
    "storage.info":"Информация о склад",

  //   order log
    "orderlog.title": "Аудит заказа",
    "orderlog.action": "Действие",
    "orderlog.details": "Детали",
    "orderlog.time": "Время",
    "orderlog.button": "Аудит",
    "orderlog.order_created": "Заказ создан",
    "orderlog.order_edited": "Заказ изменён",
    "orderlog.order_deleted": "Заказ удалён",
    "orderlog.type_changed": "Тип изменён",
    "orderlog.payment_created": "Оплата создана",
    "orderlog.payment_deleted": "Оплата удалена",
    "orderlog.user": "Пользователь",

    // ==================== SIGNATORY ====================
    "common.sidebar.signatory": "Подписанты",
    "signatory.page.title": "Подписанты",
    "signatory.add": "Добавить подписанта",
    "signatory.edit": "Редактировать подписанта",
    "signatory.field.user": "Пользователь",
    "signatory.field.fullName": "Полное ФИО",
    "signatory.field.position": "Должность",
    "signatory.field.proxyId": "Номер доверенности",
    "signatory.field.pinfl": "ПИНФЛ",
    "signatory.field.birthDate": "Дата рождения",
    "signatory.field.proxyDate": "Дата доверенности",
    "signatory.field.authorityBasis": "Основание полномочий",
    "signatory.authorityBasis.power_of_attorney": "Доверенности",
    "signatory.authorityBasis.charter": "Устав",
    "signatory.error.fullName_required": "Введите ФИО!",
    "signatory.error.position_required": "Введите должность!",

    // ==================== OFFLINE CONTRACT ====================
    "button.offline_contract": "Загрузить офлайн договор",
    "offline_contract.title": "Загрузить офлайн договор",
    "offline_contract.upload_text": "Выберите файл или перетащите сюда",
    "offline_contract.success": "Договор успешно загружен",

  },
};
